import { Button, Checkbox, Dialog, TextLink } from '@neo4j-ndl/react';
import React, { useState } from 'react';

interface Props {
  onAccept: () => void;
  onDecline: () => void;
}

export const SetReadonlyDialogStep = ({ onAccept, onDecline }: Props) => {
  const [confirmed, setConfirmed] = useState(false);

  const handleConfirmedChange = (checked: boolean) => {
    setConfirmed(checked);
  };

  return (
    <>
      <Dialog.Header>Writes made on the v4 instance during migration</Dialog.Header>
      <Dialog.Description>
        <TextLink
          type="external"
          href="https://neo4j.com/docs/operations-manual/current/authentication-authorization/manage-privileges/"
        >
          Docs
        </TextLink>
      </Dialog.Description>
      <Dialog.Content className="space-y-6">
        <div className="mb-8">
          <strong>
            No transaction that commit on this instance after the migration has been started will be transferred to the
            new instance.
          </strong>{' '}
          In order to avoid data loss during the migration process please make sure to stop all writes to this instance
          or have a mechanism to apply the same writes later to the migrated instance.
        </div>
        <div className="mb-8">
          It is advisable to change your application, setting it into a maintenance state prior to starting the
          migration.
        </div>
        <div className="mb-8">
          You could also manually DENY or REVOKE all write access to your instance using RBAC. If you do that, please
          make sure to undo those operations on the new instance after the migration if RBAC is copied.
        </div>
        <Checkbox
          label={
            'I confirm that write access is paused. I am aware that failing to do this will result in all writes to the database after migration starts being lost.'
          }
          onChange={(event) => handleConfirmedChange(event.target.checked)}
          isDisabled={false}
          isChecked={confirmed}
        />
      </Dialog.Content>
      <Dialog.Actions>
        <Button onClick={onDecline} color="neutral" fill="outlined" size="medium">
          Cancel
        </Button>
        <Button onClick={onAccept} color="primary" fill="filled" size="medium" isDisabled={!confirmed}>
          Acknowledge
        </Button>
      </Dialog.Actions>
    </>
  );
};
